module.exports = __webpack_public_path__ + "static/img/best-score-slider02.2af03e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best-score-slider02.jpg
// module id = 222
// module chunks = 0